import ResponsiveDialog from '~/src/components/mui-wrappers/responsive-dialog'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'
import { useMediaQuery } from '@mui/material'
import { CustomMuiTheme, useCustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'
import CheckActivation from '~/src/components/auth/activation/CheckActivation'

const RegisterConfirmationDialog = () => {
  const theme = useCustomMuiTheme()
  const isSmallDevice = useMediaQuery((theme: CustomMuiTheme) => theme.breakpoints.down('md'))

  return (
    <ResponsiveDialog
      openByDefault={true}
      name={AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_REGISTER_CONFIRMATION}
      showPuller={isSmallDevice}
      showCloseButton
      titleSx={{
        px: `${theme.spacing(2)} !important`,
        gap: 1
      }}
      contentSx={{
        px: 3
      }}>
      <CheckActivation />
    </ResponsiveDialog>
  )
}

export default RegisterConfirmationDialog
